<template>
  <footer class="footer text-center">
    <p class="white">
      created by creotip.io
    </p>
  </footer>
</template>
<script>
  export default {
    name: 'foot',
    data () {
      return {
        msg: 'This is footer!!!'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Foot.vue?341a2af6